import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramAdverseEventsPage } from './program-adverse-events';
import { MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule } from '@angular/material';

@NgModule({
  declarations: [
    ProgramAdverseEventsPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramAdverseEventsPage),
    MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule
  ],
})
export class ProgramAdverseEventsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-adverse-events/program-adverse-events.module.ts